import Vue from 'vue'
import VueLazyload from 'vue-lazyload'
import store from './store'
import router from './router'
import i18n from './i18n'
import App from './App.vue'
import 'swiper/css/swiper.css';

// 按需引入 Element UI 组件
import {
  Button,
  Dialog,
  Form,
  FormItem,
  Input,
  Select,
  Option,
  Message,
  MessageBox,
  Dropdown ,
  DropdownMenu,
  DropdownItem,
  Loading,
  Table,
  TableColumn,
  Empty,
  Pagination,
  Drawer
} from 'element-ui'

// 按需引入 Element UI 样式
import 'element-ui/lib/theme-chalk/button.css'
import 'element-ui/lib/theme-chalk/dialog.css'
import 'element-ui/lib/theme-chalk/form.css'
import 'element-ui/lib/theme-chalk/form-item.css'
import 'element-ui/lib/theme-chalk/input.css'
import 'element-ui/lib/theme-chalk/select.css'
import 'element-ui/lib/theme-chalk/option.css'
import 'element-ui/lib/theme-chalk/message.css'
import 'element-ui/lib/theme-chalk/message-box.css'
import 'element-ui/lib/theme-chalk/dropdown.css'
import 'element-ui/lib/theme-chalk/dropdown-menu.css'
import 'element-ui/lib/theme-chalk/dropdown-item.css'
import 'element-ui/lib/theme-chalk/loading.css'
import 'element-ui/lib/theme-chalk/table.css'
import 'element-ui/lib/theme-chalk/table-column.css'
import 'element-ui/lib/theme-chalk/empty.css'
import 'element-ui/lib/theme-chalk/pagination.css'
import 'element-ui/lib/theme-chalk/drawer.css'
//element ui 的icon
import 'element-ui/lib/theme-chalk/icon.css'
// 注册 Element UI 组件
Vue.use(Button)
Vue.use(Dialog)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Input)
Vue.use(Select)
Vue.use(Option)
Vue.use(Dropdown)
Vue.use(DropdownMenu)
Vue.use(DropdownItem)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Loading)
Vue.use(Empty)
Vue.use(Pagination)
Vue.use(Drawer)

// 挂载到 Vue 原型上
Vue.prototype.$message = Message
Vue.prototype.$msgbox = MessageBox

//服务咨询全局弹窗
//调用 this.$service()
import ServicePlugin from './plugins/service'

//产品询价全局弹窗
//调用 this.$product()
import ProductPlugin from './plugins/service'

//cro/Cdmo全局弹窗
//调用 this.$croOrCdmo(item)
import croOrCdmo from '@/plugins/croOrCdmo'

// 设置 rem 基准值
function setRem() {
  const docEl = document.documentElement
  const width = Math.min(docEl.clientWidth, 768) // 最大适配768px
  docEl.style.fontSize = width / 10 + 'px'
}

function setOptions(options) {
  // 如果已经存在百度统计脚本，先移除
  removeBaiduAnalytics()
  var _hmt = _hmt || [];
  (function() {
    var hm = document.createElement("script");
    hm.src = "https://hm.baidu.com/hm.js?7a8b6ec54b7fd0661dc8390e0ae513a8";
    var s = document.getElementsByTagName("script")[0];
    s.parentNode.insertBefore(hm, s);
    baiduScript = hm; // 保存脚本引用
  })();
}

// 百度统计脚本引用
let baiduScript = null

// 只在中文环境下调用 setOptions
function initBaiduAnalytics() {
  if (i18n.locale === 'zh') {
    setOptions()
  }
}

// 移除百度统计
function removeBaiduAnalytics() {
  if (baiduScript) {
    baiduScript.remove()
    baiduScript = null
  }
  // 清除全局变量 - 使用更安全的方式
  if (window._hmt) {
    try {
      // 尝试删除，如果失败则设置为 undefined
      delete window._hmt
    } catch (e) {
      // 如果删除失败，设置为 undefined
      window._hmt = undefined
    }
  }
}

// 监听语言变化的函数
function handleLocaleChange(newLocale) {
  if (newLocale === 'zh') {
    initBaiduAnalytics()
    // 中文环境下显示 embed-icon 元素
    showEmbedIcons()
  } else {
    removeBaiduAnalytics()
    // 非中文环境下隐藏 embed-icon 元素
    hideEmbedIcons()
  }
}

// 添加隐藏 embed-icon 元素的函数
function hideEmbedIcons() {
  const embedIcons = document.querySelectorAll('.embed-icon')
  embedIcons.forEach(element => {
    element.style.display = 'none'
  })
}

// 添加显示 embed-icon 元素的函数
function showEmbedIcons() {
  const embedIcons = document.querySelectorAll('.embed-icon')
  embedIcons.forEach(element => {
    element.style.display = 'block'

  })
}

// 初始化时检查语言
initBaiduAnalytics()
// 初始化时也检查是否需要隐藏 embed-icon
if (i18n.locale !== 'zh') {
  hideEmbedIcons()
} else {
  showEmbedIcons()
}

// 初始化
setRem()
// 监听窗口变化
window.addEventListener('resize', setRem)

Vue.config.productionTip = false

Vue.use(VueLazyload, {
  preLoad: 1.3,
  attempt: 1,
  loading: require('@/assets/imgError.jpg'),
  error: require('@/assets/imgError.jpg'),
  observer: true,
  observerOptions: {
    rootMargin: '0px',
    threshold: 0.1
  }
})

Vue.use(ServicePlugin)
Vue.use(ProductPlugin)
Vue.use(croOrCdmo)

// 开发环境下使用 mock
if (process.env.NODE_ENV === 'development') {
  require('./mock/news')
}

import PurchasePlugin from './plugins/purchase'

Vue.use(PurchasePlugin)

import GoodChart from '@/components/GoodChart.vue'

Vue.component('GoodChart', GoodChart)

import chart from '@/plugins/chart'

Vue.use(chart)

import yacooLoading from './plugins/loading'

Vue.prototype.$loading = yacooLoading

const app = new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
})

// 在 Vue 实例创建后监听语言变化
app.$watch('$i18n.locale', handleLocaleChange)

app.$mount('#app')

